<template>
  <div class="guchebao_wrapper">
    <img src="../assets/guchebao.png" />
  </div>
</template>
<script>
export default {
  name: "GuCheBao"
}
</script>
<style lang="less" scoped>
div.guchebao_wrapper {
    position: relative;
    width: 100%;
    > img {
        width: 100%;
    }
}
</style>